import { render, staticRenderFns } from "./PredicateListItem.vue?vue&type=template&id=89a898b0"
import script from "./PredicateListItem.vue?vue&type=script&lang=js"
export * from "./PredicateListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports